import { localize } from 'b2b-common/vue-config/vee-validate'
import { veeValidateLangMapping, translateConfig } from './translate'

import en from 'vee-validate/dist/locale/en.json'
import ro from 'vee-validate/dist/locale/ro.json'

localize({ en, ro })

localize(veeValidateLangMapping[translateConfig.defaultLanguage])
